<div class="info" appArrastarFecharSheet (arrastouParaFechar)="fechar()">
  <header class="info-topo">
    <div class="info-titulo-bloco">
      <span class="info-titulo">Detalhes da mensagem</span>
      <span class="info-badge" [class.info-badge-disparo]="ehDisparo">{{ ehDisparo ? 'Disparo' : 'Template' }}</span>
    </div>
    <button type="button" class="info-btn-fechar" aria-label="Fechar" (click)="fechar()">
      <img src="./assets/icones/redesign/utils/close.svg" alt="" />
    </button>
  </header>

  <div class="info-conteudo">
    <section class="info-card">
      <span class="info-card-titulo">Envio</span>
      <dl class="info-lista">
        <dt>Número de envio</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else { {{ detalhes().numeroEnvio ? (detalhes().numeroEnvio | celularMask) : '-' }} }
        </dd>

        <dt>Enviada em</dt>
        <dd>{{ mensagem.date ? (mensagem.date | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>

        <dt>Template</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else {
            <span class="info-valor-link">
              <span class="info-valor-quebra">{{ rotuloIdNome(detalhes().template?.id, detalhes().template?.nome) }}</span>
              @if (linkTemplate()) {
                <button type="button" class="info-btn-abrir" aria-label="Abrir template em nova aba" matTooltip="Ver template"
                        (click)="abrirEmNovaAba(linkTemplate())">
                  <img src="./assets/icones/redesign/utils/open-in-new-tab-blue.svg" alt="" />
                </button>
              }
            </span>
          }
        </dd>
      </dl>
    </section>

    <section class="info-card">
      <span class="info-card-titulo">Origem</span>
      <dl class="info-lista">
        <dt>Disparo</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else {
            <span class="info-valor-link">
              <span class="info-valor-quebra">{{ rotuloIdNome(detalhes().disparo?.id, detalhes().disparo?.tituloDisparo) }}</span>
              @if (linkDisparo()) {
                <button type="button" class="info-btn-abrir" aria-label="Abrir disparo em nova aba" matTooltip="Ver disparo"
                        (click)="abrirEmNovaAba(linkDisparo())">
                  <img src="./assets/icones/redesign/utils/open-in-new-tab-primary.svg" alt="" />
                </button>
              }
            </span>
          }
        </dd>

        <dt>Data do disparo</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else { {{ $any(detalhes().disparo)?.dataEnvio ? ($any(detalhes().disparo).dataEnvio | date: 'dd/MM/yyyy - HH:mm') : '-' }} }
        </dd>

        <dt>Fluxo</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else { {{ $any(detalhes().fluxo)?.nome || $any(detalhes().fluxo)?.titulo || '-' }} }
        </dd>

        <dt>Setor</dt>
        <dd>
          @if (carregando()) { <span class="skeleton info-skeleton"></span> }
          @else { {{ detalhes().setor?.nome || '-' }} }
        </dd>
      </dl>
    </section>

    <section class="info-card">
      <span class="info-card-titulo">Enviado por</span>
      @if (carregando()) {
        <div class="info-operador">
          <span class="skeleton info-avatar"></span>
          <span class="skeleton info-skeleton"></span>
        </div>
      } @else if (detalhes().operador?.nome) {
        <div class="info-operador">
          <app-avatar-pessoa [pessoa]="detalhes().operador" [tamanho]="34"></app-avatar-pessoa>
          <span class="info-operador-nome">{{ detalhes().operador?.nome }}</span>
        </div>
      } @else {
        <span class="info-vazio">Enviado automaticamente pelo sistema.</span>
      }
    </section>
  </div>

  <footer class="info-rodape">
    <button type="button" class="info-btn-secundario" (click)="fechar()">Fechar</button>
  </footer>
</div>
